import Http from "../core/http-axios-react/http/Http";
import { HttpBaseResponse } from "../core/HttpResponse";
import { I_Constant, I_ExpenseSummary, I_Summary } from "./api";

export interface Request_Summary {
  start_date: string;
  end_date: string;
}

export const getConstant = async () => {
  const results = await Http.get<HttpBaseResponse<I_Constant>>({
    url: "/exports/constant",
  });
  return results;
};

export const getIncomeSummary = async ({
  end_date,
  start_date,
}: Request_Summary) => {
  const results = await Http.get<HttpBaseResponse<I_Summary[]>>({
    url: "/invoice/summary",
    params: {
      end_date,
      start_date,
    },
  });
  return results;
};

export const getPurchaseExpenseSummary = async ({
  end_date,
  start_date,
}: Request_Summary) => {
  const results = await Http.get<HttpBaseResponse<I_Summary[]>>({
    url: "/invoice/purchase/summary",
    params: {
      end_date,
      start_date,
    },
  });
  return results;
};

export const getExpenseSummary = async ({
  end_date,
  start_date,
}: Request_Summary) => {
  const results = await Http.get<HttpBaseResponse<I_ExpenseSummary[]>>({
    url: "/expense/summary",
    params: {
      end_date,
      start_date,
    },
  });
  return results;
};
